// ================= GUEST CART =================
export const getGuestCart = () => {
  const cart = localStorage.getItem("guest_cart");
  return cart ? JSON.parse(cart) : [];
};

export const saveGuestCart = (cart) => {
  localStorage.setItem("guest_cart", JSON.stringify(cart));
};

// ================= GUEST WISHLIST =================
export const getGuestWishlist = () => {
  const wishlist = localStorage.getItem("guest_wishlist");
  return wishlist ? JSON.parse(wishlist) : [];
};

export const saveGuestWishlist = (wishlist) => {
  localStorage.setItem("guest_wishlist", JSON.stringify(wishlist));
};
